import { useState } from 'react'
import useSnackBarContext from '@contexts/snackBarContext'
import { useNavigate } from 'react-router-dom'
import useLoading from '@hooks/useLoading'
import { colors } from '@styles/theme'
import axios from '@utils/webRequests'
import styled from '@emotion/styled'
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material'
import { PositionedTopProgress } from '@elements/Loaders'
import { FormTextField } from '@elements/Inputs'

const NoButton = styled(Button)`
  border-radius: 100px;
  border: 1px solid grey;
`
  
const YesButton = styled(Button)`
  margin: 0;
  border-radius: 100px;
  color: white;
  background-color: ${colors.statusColors.right_now('primary')};
`

const paperStyles = {
  width: '90svw',
  backgroundColor: '#333333',
  textAlign: 'center',
  borderRadius: '12px',
  border: '0.5px solid rgba(255,255,255, 0.25)',
}

const slotProps = {
  paper: { style: paperStyles }
}

const LandingPasswordResetModal = ({ isOpen, setClosed }) => {
  const { isLoading, setIsLoading, isLoadingDelayed } = useLoading()
  const { addSnackBar } = useSnackBarContext()
  const [email, setEmail] = useState('')  
  const navigate = useNavigate()

  const handleClick = (e) => {
    if (isLoading) return;
    setIsLoading(true)
    axios.post('/api/auth/unauthenticated_password_resets', { email, })
      .then((res) => {
        setIsLoading(false)
        addSnackBar({ message: "We're looking up your email now" })
        navigate(-1)
      })
      .catch(() => {
        setIsLoading(false)
        addSnackBar({ message: "Email failed to send. Please try again or contact us", kind: 'error' })
      })
  }

  return (
    <Dialog
      slotProps={slotProps}
      open={isOpen}
      onClose={setClosed}>
      <PositionedTopProgress isLoadingDelayed={isLoadingDelayed} />
      <DialogTitle id="alert-dialog-slide-title">Reset Password</DialogTitle>
      <DialogContent>
        <DialogContentText
          style={{ color: 'white' }}
          id="alert-dialog-slide-description">
          Enter your email. We'll send a link to reset your password if we find the account.
        </DialogContentText>
        <br />
        <FormTextField
          name='email'
          value={email}
          placeholder='Your Email'
          onChange={(e) => setEmail(e.target.value)}
          labelProps={{ style: { width: '100%' } }}
        />
      </DialogContent>
      <DialogActions>
        <NoButton
          // NOTE: Setting the background-color here disables the purple on focus, etc
          style={{ backgroundColor: 'transparent' }}
          disabled={isLoading}
          onClick={() => navigate(-1)}
          variant='contained'>
          Exit
        </NoButton>
        <YesButton
          disabled={isLoading}
          variant='contained'
          onClick={handleClick}>
          Send Email
        </YesButton>
      </DialogActions>
    </Dialog>
  )
}

export default LandingPasswordResetModal
